module.exports = __webpack_public_path__ + "static/assets/f76fb4a979e0b11478983c49b8c0a610.svg";